<mat-tree [dataSource]="dataSource" [treeControl]="nestedTreeControl" class="packaging-system-tree">
  <mat-nested-tree-node *matTreeNodeDef="let node">
    <div
      class="mat-tree-node tree-node-row cursor"
      (click)="setSelectedLevel(node)"
      [ngClass]="selectedNode?.id === node.id && selectedNode?.index === node.index ? (isDarkTheme ? 'background-highlight-dark' : 'background-highlight') : ''">
      <button mat-icon-button matTreeNodeToggle type="button" class="tree-toggle" [ngClass]="{ invisible: !hasChild(node) }">
        <mat-icon>
          {{ nestedTreeControl.isExpanded(node) ? 'expand_more' : 'chevron_right' }}
        </mat-icon>
      </button>

      <img class="image-icon" [src]="getPackagingPartImage(node)" [matTooltip]="getImageTooltip(node)" alt="" />

      <div class="tree-node-main">
        <span class="tree-node-name" [matTooltip]="node.name">
          {{ node.name }}
        </span>

        <span class="tree-node-meta">
          <button
            type="button"
            class="tree-node-id"
            [attr.aria-label]="('common.buttons.open' | transloco) + ' ' + ('commonPackagingFields.id' | transloco) + ' ' + node.id"
            (click)="navigateToNode(node, $event)">
            {{ 'commonPackagingFields.id' | transloco }} {{ node.id }}
          </button>

          <span aria-hidden="true">·</span>

          <span class="tree-node-quantity"> ×{{ node.quantity }} </span>
        </span>
      </div>
    </div>

    <div role="group" [class.packaging-system-tree-invisible]="!nestedTreeControl.isExpanded(node)">
      <ng-container matTreeNodeOutlet></ng-container>
    </div>
  </mat-nested-tree-node>
</mat-tree>
